"use strict";

exports.__esModule = true;
exports.BusinessNotifications = void 0;
let BusinessNotifications;
exports.BusinessNotifications = BusinessNotifications;

(function (BusinessNotifications) {
  BusinessNotifications["DeliveryClosing"] = "deliveryclosing";
  BusinessNotifications["PickupClosing"] = "pickupclosing";
  BusinessNotifications["RestaurantClosed"] = "restaurantclosed";
  BusinessNotifications["OnlyFutureOrders"] = "onlyFutureOrders";
  BusinessNotifications["OlOunavailable"] = "olounavailable";
  BusinessNotifications["CantAcceptOrders"] = "cantAcceptOrders";
  BusinessNotifications["NotPremium"] = "notpremium";
  BusinessNotifications["NoPaymentMethods"] = "nopaymentmethods";
  BusinessNotifications["NoPhysicalLocation"] = "nophysicallocation";
})(BusinessNotifications || (exports.BusinessNotifications = BusinessNotifications = {}));
//# sourceMappingURL=BusinessNotifications.js.map